import { ajsClientVersion, giphyApi } from './environment-common';

// 'admin-front' means that we are bundled with the angularjs 'desktop' app,
// to be deployed on the 'admin' service

export const environment = {
  production: true,
  // Properties for the angularjs app
  frontendURLPrefix: 'https://alcmeon.com/c/v3',
  customFieldBaseUrlPrefix: `https://alcmeon.com/crm`,
  pdfUploadFrontUrl: `https://pdf-upload.alcmeon.com/client`,

  // properties for the angular app
  bundledWithAngularJSApp: true,
  isNativeApp: false,
  baseHref: '/c/v3',
  isTrackActivated: true,
  giphyApi,

  // properties for both
  apiURLPrefix: 'https://alcmeon.com/c',
  wsUrl: 'wss://ws.alcmeon.com/subscribe',
  trackURLPrefix: 'https://track.alcmeon.com/track',
  ajsClientVersion,
  isBackofficeActivated: true,
  backofficeUrlPrefix: `https://backoffice.alcmeon.com/client`,
  gaiaURLPrefix: 'https://gaia.alcmeon.com',
  sentryDsn: 'https://45fc07206e7d458e175a27db2adeb533@sentry.prod.alcmeon.net/14',
};
